import React, { useState } from 'react'
import './header.css'

const Header = () => {

  /* Change Background Header  */
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header");
    if (this.scrollY >= 80) header.classList.add ("scroll-header")
    else header.classList.remove("scroll-header")
})

  /* Toggle Menu */
    const[Toggle, showMenu] = useState(false)
    const [activeNav, setActiveNav] = useState('#home')

  return (
    <header className="header">
      <nav className="nav container">
        <a href="#home" className="nav__logo">
          Lautaro <span>Bacega</span>
        </a>

          <div className={Toggle ? 'nav__menu show-menu' : 'nav__menu'}>
            <ul className="nav__list grid">

              <li className="nav__item">
                <a 
                  href="#home" 
                  onClick={() => setActiveNav ("#home")} 
                  className={
                    activeNav === '#home' 
                    ? 'nav__link active-link'
                    : 'nav__link'
                  }
                >
                  <i className="uil uil-estate nav__icon"></i> Inicio
                </a>
              </li>

              <li className="nav__item">
                <a href="#portfolio"
                  onClick={() => setActiveNav ("#portfolio")} 
                  className={
                    activeNav === '#home' 
                    ? 'nav__link active-link'
                    : 'nav__link'
                  }
                >
                  <i className="uil uil-scenery nav__icon"></i> Portafolio
                </a>
              </li>

              <li className="nav__item">
                <a href="#calificaciones"
                  onClick={() => setActiveNav ("#calificaciones")} 
                  className={
                    activeNav === '#home' 
                    ? 'nav__link active-link'
                    : 'nav__link'
                  }
                >
                  <i className="uil uil-user nav__icon"></i> Calificaciones
                </a>
              </li>

              {
              /* <li className="nav__item">
                <a href="#skills" 
                  onClick={() => setActiveNav ("#skills")} 
                  className={
                    activeNav === '#home' 
                    ? 'nav__link active-link'
                    : 'nav__link'
                  }
                >
                  <i className="uil uil-user nav__icon"></i> Habilidades
                </a>
              </li> */
              }

              {
              /* <li className="nav__item">
                <a href="#about" 
                  onClick={() => setActiveNav ("#about")} 
                  className={
                    activeNav === '#home' 
                    ? 'nav__link active-link'
                    : 'nav__link'
                  }
                >
                  <i className="uil uil-user nav__icon"></i> Acerca de mi
                </a>
              </li> */
              }
              
              {
              /* <li className="nav__item">
                <a href="#services" 
                  onClick={() => setActiveNav ("#services")} 
                  className={
                    activeNav === '#home' 
                    ? 'nav__link active-link'
                    : 'nav__link'
                  }
                >
                  <i className="uil uil-briefcase-alt nav__icon"></i> Servicios
                </a>
              </li> */
              }

              

              {
              /* <li className="nav__item">
                <a href="#testimonios"
                  onClick={() => setActiveNav ("#testimonios")} 
                  className={
                    activeNav === '#home' 
                    ? 'nav__link active-link'
                    : 'nav__link'
                  }
                >
                  <i className="uil uil-scenery nav__icon"></i> Mis Clientes
                </a>
              </li> */
              }
              
              <li className="nav__item">
                <a href="#certificados" 
                  onClick={() => setActiveNav ("#certificados")} 
                  className={
                    activeNav === '#home' 
                    ? 'nav__link active-link'
                    : 'nav__link'
                  }
                >
                  <i className="uil uil-file-check-alt nav__icon"></i> Certificados
                </a>
              </li>

              <li className="nav__item">
                <a href="#contact" 
                  onClick={() => setActiveNav ("#contact")} 
                  className={
                    activeNav === '#home' 
                    ? 'nav__link active-link'
                    : 'nav__link'
                  }
                >
                  <i className="uil uil-message nav__icon"></i> Contacto
                </a>
              </li>

            </ul>

            <i className="uil uil-times nav__close" onClick={() => showMenu(!Toggle)}></i> 

          </div>

          <div className='nav__toggle' onClick={() => showMenu(!Toggle)}>
            <i className="uil uil-apps"></i>
          </div>
        
      </nav>
    </header>
  )
}

export default Header